import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import RegisterPage from './_domains/cadastro';
import Onboarding from './_domains/onboarding';
import ForgotPasswordPage from './_domains/forgotPassword';

import { AppContext } from './AppContext';
import { ImpersonateProvider } from './context/Impersonate';
import { TopBarProvider } from './context/TopBarContext';

import LoginPage from './_domains/login';
import ScreensInvited from './_domains/invited';
import CalendarTask from './_domains/calendarTasks';
import ScreensConference from './_domains/conference';
import ScreensExtratoBancario from './_domains/extratoBancario';
import ScreensLogout from './screens/Logout';
import ScreensAccount from './_domains/account';
import ScreeesNoMatch from './screens/NoMatch';
import { ScreensLinks } from './screens/Links';
import { ScreensDocuments } from './screens/Documents';
import { ScreensMalhaFina } from './containers/MalhaFina';
import { ScreensDividasTributarias } from './containers/DividasTributarias';
import { ScreensProcurations } from './screens/Procurations';
import { ScreensIRPF } from './containers/IRPF';
import { ScreensCertificates } from './screens/Certificates';
import { ScreensSocietario } from './_domains/societario/Index';
import { ScreensFinanceiroPainel } from './_domains/financeiro/Index';
import { ScreensRefunds } from './containers/Refunds';
import { ScreensBillsToReceive } from './screens/BillsToReceive';
import { ScreensMonthlyPayment } from './screens/Financial/MonthlyPayment';
import { ScreensBankReconciliation } from './screens/Financial/BankReconciliation';
import { ScreensContasPagar } from './screens/Financial/ContasPagar';
import { ScreensContasReceber } from './screens/Financial/ContasReceber';
import { ScreensExtrato } from './screens/Financial/Extrato';
import { ScreensBancos } from './screens/Financial/Bancos';
import { ScreensConventions } from './screens/Conventions';
import { ScreensRegisterTasks } from './screens/RegisterTasks';
import { ScreensDashboard } from './screens/Dashboard';
import { ScreensCustomers } from './_domains/customers';
import ScreensLeads from './_domains/leads';
import { ScreensRT } from './screens/RT';
import { ScreensChecklist } from './screens/Checklist';
import { ScreensLeadForms } from './screens/LeadForms';
import FormsIndication from './screens/FormsIndication';
import { ScreensPlugins } from './screens/Plugins';
import PageForms from './screens/PluginsForms/PageForms';
import PluginsClickCounter from './screens/PluginsClickCounter';
import { ScreensDocumentsDeadlines } from './screens/DocumentsDeadlines';
import { route } from './_shared/components/MainMenu/routes';
import { ScreensEmailsLogs } from './screens/EmailsLogs';
import { ScreensFeedbacks } from './screens/Feedbacks';
import { ScreensHonoraries } from './screens/Honoraries';
import { ScreensKnowledgeBase } from './screens/KnowledgeBase';
import { MarketingDomain } from './_domains/marketing';
import ScreensCampanhas from './_domains/campanhas';
import EditorCampanha from './_domains/campanhas/Editor';
import RelatorioCampanha from './_domains/campanhas/Relatorio';
import DescadastrosCampanhas from './_domains/campanhas/Descadastros';
import { MissoesDomain } from './_domains/marketing/pages/Missoes';
import { ConvitesDomain } from './_domains/marketing/pages/Convites';
import { ScreensPluginsForms } from './screens/PluginsForms';
import ScreenDefaultersReports from './screens/Reports/Defaulters';
import ScreenPartnersReport from './screens/Reports/Partners';
import ScreensSolicitacoes from './_domains/solicitations';
import ReferralProgram from './_domains/plugins/referral-program';
import Prospecting from './_domains/prospecting';
import SocialSelling from './_domains/socialSelling';
import InstagramOAuthCallback from './_domains/socialSelling/Header/InstagramOAuthCallback';
import Leadsv2 from './_domains/leadsv2';


const ScreensRoot = () => {
  const currentSubdomain = window.location.hostname.split('.')[0];
  const appDomain = process.env.REACT_APP_DOMAIN;

  if (currentSubdomain === 'ajcontabil' && window.location.pathname === '/cliente') {
    window.location.href = `https://cliente.${appDomain}`;
    return null;
  }

  // New redirect rule for /f/
  if (currentSubdomain === 'ajcontabil' && window.location.pathname.startsWith('/f/')) {
    const path = window.location.pathname.replace('/f/', '');
    window.location.href = `http://app.${appDomain}/f/ajcontabil/${path}`;
    return null;
  }

  // New redirect rule for /leads/forms/
  if (currentSubdomain === 'ajcontabil' && window.location.pathname.startsWith('/leads/forms/')) {
    const path = window.location.pathname.replace('/leads/forms/', '');
    window.location.href = `http://app.${appDomain}/leads/forms/ajcontabil/${path}`;
    return null;
  }

  if (currentSubdomain !== 'app') {
    window.location.href = `http://app.${appDomain}`;
    return null;
  }

  return (
    <Router>
      <Switch>
        <Route path="/cliente/login" render={() => { window.location.href = "https://cliente.contlabs.com.br"; return null; }} />
        <Route path={route.cadastro} component={RegisterPage} exact/>
        <Route path={route.login} component={LoginPage} />
        <Route path={route.esqueciASenha} component={ForgotPasswordPage} exact/>
        <Route path={route.esqueciASenhaToken} component={ForgotPasswordPage} />
        <Route path={route.convidado} component={ScreensInvited} />
        <Route path={route.leadsForms} component={ScreensLeadForms} />
        <Route path={route.pluginsForms} component={ScreensPluginsForms} />
        <Route path={route.formsIndication} component={FormsIndication} />

        {/* Routas que necessitam de autenticação */}
        <AppContext>
          <TopBarProvider>
          <ImpersonateProvider>
            <Switch>
              <Redirect from="/usuarios" to="/configuracoes/usuarios" exact />
              <Redirect from="/permissoes" to="/configuracoes/permissoes" exact />
              <Route path={route.onboarding} component={Onboarding}/>

              <Route path={route.customers} component={ScreensCustomers} strict/>
            <Route path={route.checklist} component={ScreensChecklist} strict/>
            <Route path={route.societario.certificados} component={ScreensCertificates} strict/>
            <Route path={route.societario.lembretes} component={ScreensProcurations} strict/>
            <Route path={route.convencoes} component={ScreensConventions} strict/>
            <Route path={route.societario.painel} component={ScreensSocietario} strict/>
            <Route path="/configuracoes" component={ScreensAccount} />
            <Route path={route.tarefas.cadastro} component={ScreensRegisterTasks} strict/>
            <Route path={route.solicitacoes} component={ScreensSolicitacoes} strict/>
            <Route path={route.itensEnviados.documentos} component={ScreensDocuments} strict/>
            <Route path={route.calendario.geral} component={CalendarTask} strict/>
            <Route path={route.tarefas.conferencia} component={ScreensConference} strict/>
            <Route path={route.tarefas.extratos} component={ScreensExtratoBancario} strict/>
            <Route path={route.financeiro.painel} component={ScreensFinanceiroPainel} strict/>
            <Route path={route.financeiro.extras} component={ScreensBillsToReceive} strict/>
            <Route path={route.financeiro.mensalidades} component={ScreensMonthlyPayment} strict/>
            <Route path={route.financeiro.comissoes} component={ScreensRefunds} strict/>
            <Route path={route.financeiro.bancos} component={ScreensBancos} strict/>
            <Route path={route.financeiro.conciliacao} component={ScreensBankReconciliation} strict/>
            <Route path={route.financeiro.contasPagar} component={ScreensContasPagar} strict/>
            <Route path={route.financeiro.contasReceber} component={ScreensContasReceber} strict/>
            <Route path={route.financeiro.extrato} component={ScreensExtrato} strict/>
            <Route path={route.crm.leads} component={ScreensLeads} strict/>
            <Route path={route.v2LeadsInssObra} component={Leadsv2} strict/>
            <Route path={route.recuperacaoTributaria} component={ScreensRT} strict/>
            <Route path={route.crm.prospeccao} component={Prospecting} strict/>
            <Route path="/oauth/instagram" component={InstagramOAuthCallback} exact />
            <Route path={route.crm.socialSelling} component={SocialSelling} strict/>
            <Route path={route.crm.referralProgram} component={ReferralProgram} strict />
            <Route path={route.links} component={ScreensLinks} strict />
            <Route path={route.irpf} component={ScreensIRPF} strict/>
            <Route path={route.malhaFina.geral} component={ScreensMalhaFina} strict/>
            <Route path={route.dividasTributarias} component={ScreensDividasTributarias} strict/>
            <Route path={route.relatorios.socios} component={ScreenPartnersReport} strict />
            <Route path={route.relatorios.inadimplentes} component={ScreenDefaultersReports} strict />
            <Route path={route.relatorios.prazos} component={ScreensDocumentsDeadlines} strict />
            <Route path={route.relatorios.honorarios} component={ScreensHonoraries} strict />
            <Route path={route.itensEnviados.emails} component={ScreensEmailsLogs} strict />
            <Route path={route.relatorios.feedbacks} component={ScreensFeedbacks} strict />
            <Route path={route.boards} component={MarketingDomain} strict/>
            <Route path={route.marketing.campanhas} component={ScreensCampanhas} exact strict/>
            <Route path={route.marketing.campanhas + '/descadastros'} component={DescadastrosCampanhas} exact strict/>
            <Route path={route.marketing.campanhas + '/:id/relatorio'} component={RelatorioCampanha} exact strict/>
            <Route path={route.marketing.campanhas + '/:id'} component={EditorCampanha} exact strict/>
            <Route path={route.marketing.missoes} component={MissoesDomain} strict/>
            <Route path={route.marketing.convites} component={ConvitesDomain} strict/>
            <Route path={route.plugins.forms} component={PageForms} strict />
            <Route path={route.plugins.clickCounter} component={PluginsClickCounter} strict />
            <Route path={route.plugins.geral} component={ScreensPlugins} strict />
            <Route path={route.baseDeConhecimento} component={ScreensKnowledgeBase} strict />
            <Route path={route.sair} component={ScreensLogout} />
            <Route path={route.dashboard} component={ScreensDashboard} exact/>
            </Switch>
          </ImpersonateProvider>
          </TopBarProvider>
        </AppContext>

        {/* Rota 404 */}
        <Route path="*" component={ScreeesNoMatch}/>
      </Switch>
    </Router>
  )
};

export default ScreensRoot;